import { JobTitleCategory, JobTitleSpecification, RequiredJobTitle } from '@pflegia/types/api/job-title';
import { ErrorType } from '@pflegia/types/api/job-title/multiposting/errors';

import { getHighestPriorityJobTitles } from './get-highest-priority-job-titles';
import { isCompanion } from './is-companion-job-title';
import { isPraxiaJobTitle } from './is-praxia-job-title';
import { isTherapistJobTitle } from './is-therapist-job-title';

export const getMainPriorityJobTitle = (jobTitles: RequiredJobTitle[]): JobTitleSpecification | undefined => {
  if (!jobTitles.length) return;
  const hpJobTitles = getHighestPriorityJobTitles(jobTitles, true) as RequiredJobTitle[];

  for (const { category, iteratee } of categoryMapping) {
    const { index, similarJobTitles } = getIndexAndFrequency(hpJobTitles, iteratee);
    if (index > -1) {
      return {
        jobTitle: hpJobTitles[index],
        category,
        similarJobTitles,
        frequency: 1 + similarJobTitles.length,
      };
    }
  }
  throw new Error(ErrorType.MissingCategory);
};

const categoryMapping = [
  { category: JobTitleCategory.Therapist, iteratee: isTherapistJobTitle },
  { category: JobTitleCategory.Companion, iteratee: isCompanion },
  { category: JobTitleCategory.Praxia, iteratee: isPraxiaJobTitle },
  { category: JobTitleCategory.Standard, iteratee: () => true },
];

const getIndexAndFrequency = (jpt: RequiredJobTitle[], iteratee: (jpt: RequiredJobTitle) => boolean) => ({
  index: jpt.findIndex(iteratee),
  similarJobTitles: jpt.filter(iteratee).slice(1),
});
